/** 对话分支 sessionKey 与深链（与 @zhin.js/ai resolveIMSessionId 一致） */

export type ImSessionScope = 'private' | 'group' | 'channel'

export interface ParsedImSessionKey {
  platform: string
  endpointId: string
  scope: ImSessionScope
  sceneId: string
}

export const SESSION_SCOPE_LABELS: Record<ImSessionScope, string> = {
  private: '私聊',
  group: '群聊',
  channel: '频道',
}

/**
 * IM 会话 sessionKey，格式：`{platform}:{endpointId}:{scope}:{sceneId}`
 * 例：icqq:75318:private:userA
 */
export function buildSessionKey(
  platform: string,
  endpointId: string,
  scope: ImSessionScope,
  sceneId: string,
): string {
  return `${platform}:${endpointId}:${scope}:${sceneId}`
}

export function agentSessionsPath(sessionKey: string): string {
  const params = new URLSearchParams()
  params.set('sessionKey', sessionKey)
  return `/agent/sessions?${params}`
}

/** 从 URL 查询参数解析 sessionKey（避免重复 decode） */
export function parseSessionKeyFromQuery(raw: string | null): string {
  if (!raw) return ''
  // URLSearchParams.get already decoded the query. Percent sequences in the
  // identifier itself are literal data, not another URI encoding layer.
  return raw.trim()
}

/** 是否为合法 sessionKey 形态（四段，含 scope） */
export function isLikelySessionKey(key: string): boolean {
  return parseImSessionKey(key) !== null
}

/** 将内部 sessionKey 拆成 Console 可展示的会话上下文。 */
export function parseImSessionKey(key: string): ParsedImSessionKey | null {
  const parts = key.trim().split(':')
  if (parts.length < 4 || !parts[0].trim() || !parts[1].trim() || !parts.slice(3).join(':').trim()) return null
  const scope = parts[2]
  if (scope !== 'private' && scope !== 'group' && scope !== 'channel') return null
  return {
    platform: parts[0],
    endpointId: parts[1],
    scope,
    sceneId: parts.slice(3).join(':'),
  }
}
